import OrderDetailInquiry from './order-detail-inquiry.vue'
export default OrderDetailInquiry
